module.exports = __webpack_public_path__ + "static/img/bg.fc03a0a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpeg
// module id = o6zb
// module chunks = 1